import { toast } from 'react-toastify';

const toastTypes = toast.TYPE

const defaultParams = {
  className: 'upper-case-txt'
}

export const notify = (type, message, params) => toast[type](message, params)

export const notifyDefault = (type, message, params) =>
  notify(type, message, { ...defaultParams, ...(params || {}) })

export let allNotifications = {}

Object.keys(toastTypes).forEach(type => {

  const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()

  allNotifications['notify' + typeCapitalized] = (message, params) => {
    notifyDefault(toastTypes[type], message, params)
  }

  allNotifications['notify' + typeCapitalized + "BottomRight"] = (message, params) => {
    notifyDefault(toastTypes[type], message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      ...params
    })
  }

})

export default {
  notify,
  notifyDefault,

  allNotifications,

  toastTypes,
}